module.exports = __webpack_public_path__ + "static/media/gajari.ee31cdd6.svg";